import React from 'react'
import { ReactComponent as TabsIllustration } from 'assets/svg/shared/multiple_tabs.svg'
import './MultipleTabs.scss'
import { useTranslation } from 'react-i18next'
import { BroadcastMessage } from 'common/Enums'
import Broadcast from 'common/Broadcast'

import Webphone from 'common/Webphone'
import { isAnotherActiveTab, setCurrentTabPrime } from 'hooks'

export function MultipleTabs() {
    const { t } = useTranslation()

    const forcePrime = () => {
        setCurrentTabPrime()
        Webphone.attemptRegistration()
        Broadcast.postMessage({
            type: BroadcastMessage.PrimeTabChanged,
            payload: true
        })
    }

    const focusActive = () => {
        if (isAnotherActiveTab()) {
            Broadcast.postMessage({
                type: BroadcastMessage.FocusActiveTab,
                payload: true
            })
        } else {
            Webphone.attemptRegistration()
        }
    }

    return (
        <div className="multiple-tabs-page">
            <h2 className="multiple-tabs-page__title">{t('multipleTabsTitle')}</h2>
            <div className="d-flex flex-column align-items-center">
                <TabsIllustration />
            </div>
            <div className="d-flex flex-column">
                <p className="multiple-tabs-page__text">{t('multipleTabsDescription')}</p>
                <div className="d-flex justify-content-between">
                    <button type="button" className="btn btn-secondary" onClick={focusActive}>
                        {t('focusActive')}
                    </button>
                    <button type="button" className="btn btn-primary" onClick={forcePrime}>
                        {t('forceActive')}
                    </button>
                </div>
            </div>
        </div>
    )
}
